import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  addDoc,
  updateDoc,
} from "firebase/firestore";
import { firestore } from "../../components/firebase/FirebaseConfig";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./FavoriteFriend";
import { ReactSVG } from "react-svg";
import { addFriend } from "../../components/friend/AddFriend";
import { or } from "firebase/firestore";
import {
  favFriend,
  favFriendCaddie,
  unfavFriend,
  unfavFriendCaddie,
} from "../../components/friend/FavFriend";
import { ChatTo } from "../../components/chat/Chat";
function ModalPlayerDetail(props) {
  const userData = useSelector((state) => state.user.data);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const navigate = useNavigate();

  const [friendState, setFriendState] = useState("");

  useEffect(() => {
    async function fetchData() {
      const playerUid = props.filteredMembersIsPlayer.uid || "";

      let isFriend = false;

      const q3 = query(
        collection(firestore, "friends"),
        where("friendId", "==", playerUid),
        where("userId", "==", userData?.uid)
      );

      const q2 = query(
        collection(firestore, "friends"),
        where("friendId", "==", userData?.uid),
        where("userId", "==", playerUid)
      );

      const querySnapshot2 = await getDocs(q2);
      querySnapshot2.forEach((doc2) => {
        if (doc2.data().status === "active") {
          isFriend = true;
        }
      });

      const querySnapshot3 = await getDocs(q3);
      querySnapshot3.forEach((doc3) => {
        if (doc3.data().status === "active") {
          isFriend = true;
        }
      });

      if (isFriend) {
        setFriendState("friend");
      } else {
        const q4 = query(
          collection(firestore, "friendRequests"),
          where("fromUserId", "==", userData?.uid),
          where("toUserId", "==", playerUid)
        );

        const q5 = query(
          collection(firestore, "friendRequests"),
          where("fromUserId", "==", playerUid),
          where("toUserId", "==", userData?.uid)
        );

        let statePending = false;
        let stateRequesting = false;

        const querySnapshot4 = await getDocs(q4);
        querySnapshot4.forEach((doc4) => {
          if (doc4.data().status === "pending") {
            setFriendState("not-friend-pending");
            statePending = true;
          }
        });

        const querySnapshot5 = await getDocs(q5);
        querySnapshot5.forEach((doc5) => {
          if (doc5.data().status === "pending") {
            setFriendState("not-friend-requesting");
            stateRequesting = true;
          }
        });

        if (!statePending && !stateRequesting) {
          setFriendState("not-friend");
        }
      }
    }

    if (userData) {
      fetchData();
    }
  }, [userData, props.filteredMembersIsPlayer]);

  const handleClose = () => {
    props.setShowMoadalPlayersDetail(false);
  };

  const handleFavorite = async (uid) => {
    await unfavFriend(userData.uid, uid);
    props.setFavoritePlayers(false);
  };

  const handleChat = async (dooNineId) => {
    const result = await ChatTo(userData.dooNineId, dooNineId);
    if (result) {
      navigate("/chat-room?channelId=" + result[0].channel_url);
    }
    // const response = await axios.get(
    //   `https://api-DC03AD4D-419B-41A2-8305-AA8A4B972CA5.sendbird.com/v3/group_channels?members_exactly_in=${userData.dooNineId}&show_member=false&members_exactly_in=${dooNineId}`,
    //   {
    //     headers: {
    //       "Content-Type": "application/json; charset=utf8",
    //       "Api-Token": "6ddb1df5e1057376e6f0567720039810a957e8cf",
    //     },
    //   }
    // );

    // if (response.data.channels.length > 0) {
    //   isMobile
    //     ? navigate("/chat-room", {
    //         state: {
    //           channelUrl: response.data.channels[0].channel_url,
    //           previousPage: "caddie",
    //         },
    //       })
    //     : navigate("/chat", {
    //         state: {
    //           channelUrl: response.data.channels[0].channel_url,
    //           previousPage: "caddie",
    //         },
    //       });
    // } else {
    //   const response2 = await axios.post(
    //     "https://api-DC03AD4D-419B-41A2-8305-AA8A4B972CA5.sendbird.com/v3/group_channels",
    //     {
    //       user_ids: [userData.dooNineId, dooNineId],
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json; charset=utf8",
    //         "Api-Token": "6ddb1df5e1057376e6f0567720039810a957e8cf",
    //       },
    //     }
    //   );
    //   isMobile
    //     ? navigate("/chat-room", {
    //         state: {
    //           channelUrl: response.data.channels[0].channel_url,
    //           previousPage: "caddie",
    //         },
    //       })
    //     : navigate("/chat", {
    //         state: {
    //           channelUrl: response.data.channels[0].channel_url,
    //           previousPage: "caddie",
    //         },
    //       });
    // }
  };

  const handleProfileClick = (uid) => {
    if (!uid) return;
    if (uid === userData.uid) {
      navigate("/userPage");
    } else {
      navigate("/user", { state: { uid: uid } });
    }
  };

  // console.log("props.caddieData", props.caddieData);
  // console.log("props.caddieProfile", props.caddieProfile);
  // console.log("props.courseData", props.courseData);
  // console.log(friendState);
  // console.log(props.filteredMembersIsPlayer)
  return (
    <>
      {/* Modal Caddie detail */}
      <Modal
        show={props.showMoadalPlayersDetail}
        onHide={handleClose}
        scrollable
      >
        <Modal.Body style={{ padding: "0rem" }}>
          <div className="card-image w-100 mb-3 position-relative">
            {/* Icon Star */}
            {props.filteredMembersIsPlayer.isStar ? (
              <h4
                className="fw-600 position-absolute z-index-1 ls-3 font-xssss text-white"
                style={{
                  top: "10px",
                  right: "10px",
                }}
              >
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-CaddieStar.svg"
                  style={{ width: "25px", height: "25px" }}
                />
              </h4>
            ) : null}

            {/* Icon Pro */}
            {props.filteredMembersIsPlayer.isPro ? (
              <h4
                className="fw-600 position-absolute z-index-1 ls-3 font-xssss text-white"
                style={{
                  top: props.filteredMembersIsPlayer.isStar ? "45px" : "10px",
                  right: "10px",
                }}
              >
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-ProCaddie.svg"
                  style={{ width: "25px", height: "25px" }}
                />
              </h4>
            ) : null}

            {/* Statue online & Name */}
            <h4
              className="fw-700 position-absolute z-index-1 ls-3 font-xss text-white"
              style={{
                bottom: "25px",
                left: "15px",
              }}
              onClick={() =>
                handleProfileClick(props.filteredMembersIsPlayer.uid)
              }
            >
              <span
                style={{
                  height: "10px",
                  width: "10px",
                  backgroundColor: "#10d876",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "9px",
                  boxShadow: "0 0 0 3px white",
                }}
              ></span>
              {props.filteredMembersIsPlayer.firstName}{" "}
              {props.filteredMembersIsPlayer.lastName}
            </h4>

            {/* Chat Icon */}
            <h4
              onClick={() =>
                handleChat(props.filteredMembersIsPlayer.dooNineId)
              }
              className="fw-600 position-absolute z-index-1 ls-3 font-xssss text-white"
              style={{
                bottom: "20px",
                right: "10px",
                cursor: "pointer",
              }}
            >
              <ReactSVG
                src="assets/icon/CaddieFriendFav-Chat.svg"
                style={{ width: "45px", height: "45px" }}
              />
            </h4>

            {/* Chat Favorite */}
            <h4
              onClick={() => handleFavorite(props.filteredMembersIsPlayer.uid)}
              className="fw-600 position-absolute z-index-1 ls-3 font-xssss text-white"
              style={{
                bottom: "20px",
                right: "60px",
                cursor: "pointer",
              }}
            >
              {props.favoritePlayers ? (
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-Fav.svg"
                  style={{ width: "45px", height: "45px" }}
                />
              ) : (
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-UnFav.svg"
                  style={{ width: "45px", height: "45px" }}
                />
              )}
            </h4>

            <Carousel>
              <Carousel.Item>
                <img
                  src={props.filteredMembersIsPlayer.profileImage}
                  alt="hotel"
                  className="w-100"
                  style={{
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: "15px",
                  }}
                />
              </Carousel.Item>
            </Carousel>
          </div>
          <div className="card-body pt-0">
            

            <h6 className="font-xss text-grey-700 fw-400 mt-0 mb-3">
              {props.filteredMembersIsPlayer.description}
            </h6>

            <div className="clearfix"></div>

            {/* <span className="font-lg fw-700 mt-0 pe-3 ls-2 lh-32 d-inline-block text-success float-left">
              <span className="font-xsssss">$</span> value.price{" "}
              <span className="font-xsssss text-grey-500">/ mo</span>{" "}
            </span>
            <Link to="/course-detail" className="position-relative d-block">
              <i className="btn-round-sm bg-primary-gradiant text-white font-sm feather-chevron-right"></i>
            </Link> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {friendState == "friend" ? (
            <button
              className="btn text-white font-xsss"
              style={{ backgroundColor: "#EE3D7F" }}
            >
              <span
                style={{
                  display: "inline-block",
                  marginRight: "5px",
                }}
              >
                {" "}
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-Friends.svg"
                  style={{ width: "25px", height: "25px" }}
                />
              </span>
              Friend
            </button>
          ) : friendState == "not-friend-pending" ||
            friendState == "not-friend-requesting" ? (
            <button
              className="btn text-white font-xsss"
              style={{ backgroundColor: "#EE3D7F" }}
            >
              <span
                style={{
                  display: "inline-block",
                  marginRight: "5px",
                }}
              >
                {" "}
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-CancelRequest.svg"
                  style={{ width: "25px", height: "25px" }}
                />
              </span>
              Pending
            </button>
          ) : (
            <button
              className="btn text-white font-xsss"
              style={{ backgroundColor: "#EE3D7F" }}
              onClick={() =>
                addFriend(props.filteredMembersIsPlayer.uid, userData.uid)
              }
            >
              <span
                style={{
                  display: "inline-block",
                  marginRight: "5px",
                }}
              >
                {" "}
                <ReactSVG
                  src="assets/icon/CaddieFriendFav-AddFriend.svg"
                  style={{ width: "25px", height: "25px" }}
                />
              </span>
              Add Friend
            </button>
          )}

          <button
            className="btn font-xsss"
            style={{
              backgroundColor: "#F5F5F5",
              color: "#212529",
            }}
            onClick={handleClose}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalPlayerDetail;
